var map = {
	"./f1.png": "./src/assets/wallpapers/f1.png",
	"./f2.png": "./src/assets/wallpapers/f2.png",
	"./l1.png": "./src/assets/wallpapers/l1.png",
	"./l2.png": "./src/assets/wallpapers/l2.png",
	"./l3.png": "./src/assets/wallpapers/l3.png",
	"./l4.png": "./src/assets/wallpapers/l4.png",
	"./l5.png": "./src/assets/wallpapers/l5.png",
	"./l6.png": "./src/assets/wallpapers/l6.png",
	"./w1.png": "./src/assets/wallpapers/w1.png",
	"./w2.png": "./src/assets/wallpapers/w2.png",
	"./w3.png": "./src/assets/wallpapers/w3.png",
	"./w4.png": "./src/assets/wallpapers/w4.png",
	"./w5.png": "./src/assets/wallpapers/w5.png",
	"./w6.png": "./src/assets/wallpapers/w6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/wallpapers sync .*\\.png";